/**
 * Date-extensions locale Dutch (Belgium) [nl-be]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('nl-be', {
    monthNames: ['Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'],
    monthShortNames: ['Jan.','Feb.','Mrt.','Apr.','Mei','Jun.','Jul.','Aug.','Sep.','Okt.','Nov.','Dec.'],
    dayNames: ['Zondag','Maandag','Dinsdag','Woensdag','Donderdag','Vrijdag','Zaterdag'],
    dayShortNames: ['Zo.','Ma.','Di.','Wo.','Do.','Vr.','Za.']
});
